import { addMilliseconds, differenceInMilliseconds } from "date-fns";
import { useEffect, useRef, useState } from "react";

const useCountdown = ({ durationInMs = 0, start = false }) => {
  const [timeLeft, setTimeLeft] = useState("");
  const endDateRef = useRef(null);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!start) {
      return;
    }

    endDateRef.current = addMilliseconds(new Date(), durationInMs);

    const tick = () => {
      if (!endDateRef.current) {
        return;
      }
      const remaining = differenceInMilliseconds(endDateRef.current, new Date());

      if (remaining >= 0) {
        const total = Math.ceil(remaining / 1000);
        const minutes = Math.floor(total / 60);
        const seconds = total % 60;
        setTimeLeft(`${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`);
      } else {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
        }
        intervalRef.current = null;
      }
    };

    tick();
    intervalRef.current = window.setInterval(tick, 1000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      intervalRef.current = null;
    };
  }, [start, durationInMs]);

  return { timeLeft };
};

export default useCountdown;
